// extracted by mini-css-extract-plugin
export default {"container":"FirmwarePage_container__Xtx2m","firmware_container":"FirmwarePage_firmware_container__S5LnI","items":"FirmwarePage_items__NKFrY","item":"FirmwarePage_item__Upr6g"};